import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { useNavigate } from 'react-router';
import { RoutePath } from 'features/routing/constants';
import type { URLOpenListenerEvent } from '@capacitor/app';

export const useAppUrlListener = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    void App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      const slug = event.url.split(import.meta.env.PUBLIC_DOMAIN).pop();
      // in the native app when we deep link user to the root path and the app was not in the memory
      // even if user was signed in for some reason he is not redirected to the Home page which is default for the signed in users
      // therefore we redirect deep links to Root straight to the Home and if it turns out user is not logged in
      // user is properly redirected to the Login page
      if (slug && slug !== RoutePath.Root) {
        void navigate(slug);
      } else {
        void navigate(RoutePath.Home());
      }
    });
    return () => {
      void App.removeAllListeners();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- this effect should only run once, since capacitor does not support removeListener
  }, []);
};
